import React from "react";
import "./AboutUs.css";
const AboutUsFooter = () => {
  return (
    <div className="aboutUsFooterContainer">
      <h3>
        Join <span>Prizma Academy</span> and embark on your language learning
        journey today!
      </h3>
    </div>
  );
};

export default AboutUsFooter;
